import { Ref, ref } from "vue";
import { MiddlewareContext } from "@/router/middlewares";

const tag: Ref<string | null> = ref(null);

function capture(context: MiddlewareContext) {
  const { rel } = context.to.query;

  if (!Array.isArray(rel) && rel !== undefined) {
    tag.value = rel;
  }

  return context.next();
}

export function useAffiliate() {
  return {
    capture,
    tag,
  };
}
